import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react'
import React from 'react'
import RequestApproval from '../Components/RequestApproval'
import ScnApproval from '../Components/ScnApproval'
import SraApproval from '../Components/SraAppproval'
import TransferApproval from '../Components/TransferApproval'
import MainLayout from '../Layouts/Index'
import Seo from '../Utils/Seo'

export default function Approval() {
    return (
        <MainLayout>
            <Seo title='Approval' description='EKO Approval IMS' />

            <Tabs variant='enclosed'>
                <TabList>
                    <Tab _selected={{ color: 'white', bg: 'teal' }} _hover={{ color: 'white', bg: 'teal' }}>SRA</Tab>
                    <Tab _selected={{ color: 'white', bg: 'teal' }} _hover={{ color: 'white', bg: 'teal' }}>SCN</Tab>
                    <Tab _selected={{ color: 'white', bg: 'teal' }} _hover={{ color: 'white', bg: 'teal' }}>Request</Tab>
                    <Tab _selected={{ color: 'white', bg: 'teal' }} _hover={{ color: 'white', bg: 'teal' }}>Transfer</Tab>
                </TabList>
                <TabPanels>
                    <TabPanel>
                       <SraApproval/>
                    </TabPanel>
                    <TabPanel>
                       <ScnApproval/>
                    </TabPanel>
                    <TabPanel>
                       <RequestApproval/>
                    </TabPanel>
                    <TabPanel>
                       <TransferApproval/>
                    </TabPanel>
                </TabPanels>
            </Tabs>

        </MainLayout>
    )
}

